export default __webpack_public_path__ + "static/media/hd3.3484d3ba.webp";